<template>
<div class="template message">
  <el-row :gutter="24">
    <el-col :span="14">
      <div class="boxShadow" :style="{'minHeight':util.accDiv(height,1.16)+'px'}">
        <div class="title">
          <span>{{$t('im.message.title')}}</span>
          <p>{{$t('im.message.titleCon')}}</p>
        </div>
        <div class="tabList">
          <ul>
            <li><p>{{$t('im.message.form')}}</p><p>{{$t('im.message.isRequired')}}</p><p>{{$t('im.message.adaptationBizCode')}}</p></li>
            <li v-for="item in tabData">
              <div class="item">{{item.name}}</div>
              <div class="item"><el-checkbox v-model="item.formRequired"></el-checkbox></div>
              <div class="item">
                <el-checkbox v-for="itemBusiness in item.businessGroupData"  v-model="itemBusiness.isRequired">{{itemBusiness.name}}</el-checkbox>
              </div>
            </li>
          </ul>
        </div>
        <div class="flexStart">
          <el-button type="primary" size="small" @click="submitFormData">{{$t('im.bt.definite')}}</el-button>
          <el-button size="small">{{$t('im.bt.cancel')}}</el-button>
        </div>
      </div>
    </el-col>
    <el-col :span="10">
      <div class="boxShadow" :style="{'minHeight':util.accDiv(height,1.16)+'px'}">
        <div class="title">
          <span>{{$t('im.message.EffectPreview')}}</span>
        </div>
        <el-tabs v-model="businessGroupCode" @tab-click="changeTab">
          <el-tab-pane v-for="(item,index) in businessGroupData" :name="item.code">
            <span slot="label">{{item.name}}</span>
            <el-form class="localeCon">
              <el-form-item :label="$t('im.common.locale')" v-if="langList&&langList.length>0">
                <el-select v-model="langId" :placeholder="$t('im.common.placeholderLanguage')" @change="changeLang">
                  <el-option
                    v-for="item in langList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div class="messageBox">
              <div class="boxTit"><span>{{$t('im.common.tip')}}</span></div>
              <div class="boxEdit"><p @click="goToOftenPop">{{messagePrompt}}</p></div>
              <div class="boxList">
                <ul>
                  <li v-for="item in tabData" v-if="item.businessGroupData[index].isRequired">
                    <span>
                      <em v-if="item.formRequired">*</em>
                      {{item.name}}
                    </span>
                    <p></p>
                  </li>
                  <li><span><em>*</em>{{$t('im.message.message')}}</span><p class="height"></p></li>
                </ul>
              </div>
            </div>
            <div class="messageSuc" v-if="messageSucPrompt&&util.isNotEmpty(messageSucPrompt.replace(/(<([^>]+)>)/ig, '').replace(/\s/g, ''))">
              <span>{{$t('im.message.messageSuc')}}</span>
              <div class="sucCon" v-html="messageSucPrompt"></div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-col>
  </el-row>
  <el-dialog :title="$t('im.message.editMessageGuide')" :visible.sync="isToOftenPop">
    <el-form class="div_form" label-width="120px">
      <el-form-item :label="$t('im.message.messageGuide')">
        <el-input v-model="titleTxt"></el-input>
      </el-form-item>
      <el-form-item :label="$t('im.message.messageSuc')">
        <quill ref="quill" :uploadUrl="uploadUrl" :quillId="quillId" :height="200"></quill>
      </el-form-item>
    </el-form>
    <div class="flexCenter">
      <el-button type="primary" @click="submitSave">{{$t('im.bt.definite')}}</el-button>
      <el-button @click="isToOftenPop=false">{{$t('im.bt.cancel')}}</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
  require('@/styles/IM/template.css')
  require('@/styles/IM/message.css')
  import apiDeployManagement from "@/api/im/deployManagement"
  import { localRead} from '@/utils/tools'
  import quill from '@/views/IM/model/quill.vue'
  import Util from '@/utils/IM/tradeDataUtil'
  export default {
    name: 'message',
    components: {
      quill
    },
    data() {
      return {
        util: Util,
        height: '',
        userInfo: JSON.parse(localRead('sys_userInfo_IM')),  //用户信息
        tabData: [],//表单数据列表
        formData: [
          { name: window.$t('im.common.name'), formType: '0' },
          { name: window.$t('im.common.phone'), formType: '1' },
          { name: window.$t('im.common.email'), formType: '2' },
          { name: window.$t('im.common.tel'), formType: '3' },
          { name: window.$t('im.common.qq'), formType: '4' },
          { name: window.$t('im.common.weChat'), formType: '5' },
          { name: window.$t('im.common.zalo'), formType: '6' },
          { name: window.$t('im.common.facebook'), formType: '7' },
          { name: window.$t('im.common.whatsApp'), formType: '8' },
        ], //表单选项列表
        messageType: '',//0：新增，1：编辑
        messageID: '',//当前数据ID
        businessGroupData: JSON.parse(localRead('sys_userInfo_IM')).businessIdUser,  //业务编码列表
        businessGroupCode: '',  //业务编码Code
        langList: JSON.parse(localRead('locale_IM')),  //语言列表
        langId: 'zh_CN',  //默认显示语言的ID
        messagePromptList: [],//留言引导语列表
        messagePrompt: window.$t('im.message.clickEditMessageGuide'),//留言引导语
        messageSucPrompt: "",//留言引导语
        isToOftenPop: false,//弹窗是否显示
        promptType: '',//0：新增，1：编辑
        promptID: '',//当前数据ID
        titleTxt: '',//留言引导语内容
        quillId: 'quillID',
        uploadUrl: process.env.VUE_APP_BASE_API + '/serviceBusiness/api/upload/uploadMulti',
      }
    },
    methods: {
      docHeight() {
        this.height =  window.innerHeight || document.documentElement.clientHeight
      },
      /*初始化业务组*/
      initBusinessGroup() {
        if (this.businessGroupData.length > 0) {
          this.businessGroupCode = this.businessGroupData[0].code
        }
      },
      /*初始化表单配置*/
      initForm() {
        let formNewsData = JSON.parse(JSON.stringify(this.formData)),
          newData = JSON.parse(JSON.stringify(this.businessGroupData))
        for (const j in newData) {
          newData[j].isRequired = false
        }
        for (const i in formNewsData) {
          formNewsData[i].formRequired = false
          formNewsData[i].businessGroupData = JSON.parse(JSON.stringify(newData))
        }
        this.tabData = formNewsData
      },
      /*业务组tab切换*/
      changeTab(tab) {
        this.businessGroupCode = tab.name
        this.initClientMessage();
      },
      /*选择弹窗语言*/
      changeLang(val) {
        this.brushPromptList(this.messagePromptList)
      },
      /*初始化留言配置*/
      initMessage() {
        let data = {
          companyId: this.userInfo.companyId
        }
        apiDeployManagement.queryConLeaveFormList(data).then(res => {
          if (res.code == 0) {
            let data, fromBizCode = []
            if (res.result.length > 0) {
              this.messageType = 1
              data = res.result
              for (const i in data) {
                this.tabData[i].id = data[i].id
                if (data[i].formRequired == 1) this.tabData[i].formRequired = true
                if (data[i].formRequired == 0) this.tabData[i].formRequired = false
                if (data[i].fromBizCode.indexOf(',') > -1) {
                  fromBizCode = data[i].fromBizCode.split(',')
                } else {
                  fromBizCode = [data[i].fromBizCode]
                }
                for (const j in this.tabData[i].businessGroupData) {
                  for (const k in fromBizCode) {
                    if (this.tabData[i].businessGroupData[j].code == fromBizCode[k]) {
                      this.tabData[i].businessGroupData[j].isRequired = true
                    }
                  }
                }
              }
            } else {
              this.messageType = 0
            }
          }
        })
      },
      /*添加留言配置*/
      addMessageData(){
        let newData = JSON.parse(JSON.stringify(this.tabData))
        for (const i in this.tabData) {
          if (this.tabData[i].formRequired) {
            newData[i].formRequired = 1
          } else {
            newData[i].formRequired = 0
          }
          let businessGroupData = newData[i].businessGroupData, businessIDs = []
          for (const j in businessGroupData) {
            if (businessGroupData[j].isRequired) {
              businessIDs.push(businessGroupData[j].code)
            }
          }
          newData[i].fromBizCode = businessIDs.join(',')
          delete newData[i].name
          delete newData[i].businessGroupData
          newData[i].companyId = this.userInfo.companyId
          newData[i].operator = this.userInfo.id
          newData[i].operatorName = this.userInfo.displayName
        }
        apiDeployManagement.addBatchConLeaveForm(newData).then(res => {
          if (res.code == 0 && res.result == true) {
            this.$message.success(window.$t('im.common.addSuc'))
            this.initMessage()
          } else {
            this.$message.error(window.$t('im.common.addFail'))
          }
        })
      },
      /*更新留言配置*/
      updateMessageData(){
        let newData = JSON.parse(JSON.stringify(this.tabData))
        for (const i in this.tabData) {
          if (this.tabData[i].formRequired) {
            newData[i].formRequired = 1
          } else {
            newData[i].formRequired = 0
          }
          let businessGroupData = newData[i].businessGroupData, businessIDs = []
          for (const j in businessGroupData) {
            if (businessGroupData[j].isRequired) {
              businessIDs.push(businessGroupData[j].code)
            }
          }
          newData[i].fromBizCode = businessIDs.join(',')
          delete newData[i].name
          delete newData[i].businessGroupData
          newData[i].companyId = this.userInfo.companyId
          newData[i].operator = this.userInfo.id
          newData[i].operatorName = this.userInfo.displayName
        }
        apiDeployManagement.updateBatchConLeaveForm(newData).then(res => {
          if (res.code == 0 && res.result == true) {
            this.$message.success(window.$t('im.common.updateSuc'))
            this.initMessage()
          } else {
            this.$message.error(window.$t('im.common.updateFail'))
          }
        })
      },
      /*保存留言配置*/
      submitFormData() {
        if (this.messageType == 0) {
          this.addMessageData()
        } else if (this.messageType == 1) this.updateMessageData()
      },
      /*引导语弹窗*/
      goToOftenPop() {
        this.isToOftenPop = true
        this.brushPromptList(this.messagePromptList)
        this.$nextTick(() => {
          this.$refs.quill.init(this.messageSucPrompt)
        })
      },
      /*刷选客户端留言引导语*/
      brushPromptList(data) {
        let flag = false
        if (data && data.length > 0) {
          for (const i in data) {
            if (data[i].locale == this.langId) {
              flag = true
              this.promptType = 1
              this.messagePrompt = data[i].promptContent
              this.titleTxt = data[i].promptContent
              this.promptID = data[i].id
              this.messageSucPrompt = data[i].redirectContent
            }
          }
        }
        if (!flag) {
          this.promptType = 0
          this.messagePrompt = window.$t('im.message.clickEditMessageGuide')
          this.titleTxt = ''
          this.messageSucPrompt = ""
          this.$nextTick(() => {
            this.$refs.quill.init('')
          })
        }
      },
      /*初始化客户端留言引导语*/
      initClientMessage(){
        let data = {
          operator: this.userInfo.id,
          operatorName: this.userInfo.displayName,
          companyId: this.userInfo.companyId,
          bizCode: this.businessGroupCode,
        }
        apiDeployManagement.queryConLeavePromptList(data).then(res => {
          if (res.code == 0) {
            if (res.result) {
              this.messagePromptList = res.result
              this.brushPromptList(res.result)
            } else {
              this.promptType = 0
              this.messagePromptList = []
              this.messagePrompt = window.$t('im.message.clickEditMessageGuide')
              this.titleTxt = ''
              this.messageSucPrompt = ""
            }
          }
        })
      },
      /*新增客户端留言引导语*/
      addClientMessagePrompt(){
        let data = {
          operator: this.userInfo.id,
          operatorName: this.userInfo.displayName,
          companyId: this.userInfo.companyId,
          bizCode: this.businessGroupCode,
          locale: this.langId,
          promptContent: this.titleTxt,
          redirectContent:this.$refs.quill.getHtml()
        }
        apiDeployManagement.addConLeavePrompt(data).then(res => {
          if (res.code == 0) {
            this.isToOftenPop = false
            this.initClientMessage()
          }
        })
      },
      /*编辑客户端留言引导语*/
      updateClientMessagePrompt(){
        let data = {
          operator: this.userInfo.id,
          operatorName: this.userInfo.displayName,
          companyId: this.userInfo.companyId,
          bizCode: this.businessGroupCode,
          locale: this.langId,
          promptContent: this.titleTxt,
          redirectContent:this.$refs.quill.getHtml(),
          id: this.promptID
        }
        apiDeployManagement.updateConLeavePrompt(data).then(res => {
          if (res.code == 0) {
            this.isToOftenPop = false
            this.initClientMessage()
          }
        })
      },
      /*保存客户端留言引导语*/
      submitSave() {
        var regex = /(<([^>]+)>)/ig
        if (Util.isEmpty(this.titleTxt.replace(/\s/g, '')) || Util.isEmpty(this.$refs.quill.getHtml().replace(regex, "").replace(/\s/g, ''))) {
          this.$message.error(window.$t('im.common.notNull'))
        } else {
          if (this.promptType == 0) {
            this.addClientMessagePrompt()
          } else if (this.promptType == 1) this.updateClientMessagePrompt()
        }
      }
    },
    mounted() {
      this.docHeight();
      this.initBusinessGroup();
      this.initForm();
      this.initMessage()
      this.initClientMessage();
    }
  }
</script>
